import { Component, input, output } from '@angular/core';
import { EnumerationFilter } from '../../../../types/Metrics';

@Component({
  selector: 'app-enumeration-filter',
  imports: [],
  templateUrl: './enumeration-filter.component.html',
  styleUrl: './enumeration-filter.component.css',
})
export class EnumerationFilterComponent {
  public filter = input.required<EnumerationFilter>();
  public filterUpdate = output<string>();

  protected selectionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.filterUpdate.emit(target.value);
  }
}
